import React from 'react';
import { Link } from "react-router-dom";
import './style.css';
import 'react-widgets/dist/css/react-widgets.css';
import Perspectivecrop from '../PerspectiveCrop'
import { Constants, ToolTipMessages } from '../../data/Constants'
import Dropzone from 'react-dropzone'
import Tooltip from '@material-ui/core/Tooltip';
import { Card } from 'react-bootstrap';
import NewTemplateIcon from '../../assets/images/new-template-icon.png'
import Modal from 'react-bootstrap/Modal';

class UploadImage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            file: null,
            fileData: null,
            className: '',
            zoom: 1,
            minimumScale: 0.4,
            show: false,
            modalHeading: '',
            modalInfo: '',
            showLoader: false,
            perspectiveCrop: false,
            imgWidth: 0,
            imgHeight: 0
        }
        this.child = React.createRef();
    }

    componentDidMount() {
        let self = this;
        if (this.props.imageData) {
            this.setState({
                file: URL.createObjectURL(this.props.imageData),
                fileData: this.props.imageData,
            }, () => this.fitToFrame(self))
        }
    }

    fitToFrame = (self) => {
        var img = new Image();
        img.src = this.state.file
        img.onload = function () {
            const transformDivParent = self.transformDiv.parentNode.parentNode;
            let zoomX = transformDivParent.clientWidth / this.width;
            let zoomY = transformDivParent.clientHeight / this.height;
            let zoom = Math.min(zoomX, zoomY)
            self.setState({
                zoom: zoom - 0.01,
                imgWidth: this.width,
                imgHeight: this.height,
                minimumScale: zoom
            })
        }
    }

    onFileUpload = (files) => {
        let file = files[0]
        let self = this;
        if (files.length !== 0 && this.validateSize(file)) {
            this.setState({
                file: URL.createObjectURL(file),
                fileData: file,
            }, () => this.fitToFrame(self))
        }
    }

    cropComplete = (src) => {
        this.setState({
            file: src,
            perspectiveCrop: false,
            zoom: 1
        })
        this.createFile(src);
    }

    perspectiveCropImage = () => {
        if (this.state.file) {
            let self = this;
            this.setState({
                perspectiveCrop: true
            }, () => this.fitToFrame(self))
        }
    }

    cancelCropBtnClick = () => {
        this.setState({
            perspectiveCrop: false,
            zoom: 1
            })
    }

    handleClose = () => {
        this.setState({ show: false });
        if (this.state.refreshView) {
            window.location.reload();
            this.setState({
                refreshView: false
            })
        }
    }

    handleShow = () => this.setState({ show: true });

    async createFile(src) {
        let self = this
        let response = await fetch(src);
        let data = await response.blob();
        let metadata = {
            type: 'image/jpeg'
        };
        let file = new File([data], Constants.imgFileName, metadata);
        this.setState({
            fileData: file
        }, () => this.fitToFrame(self))
    }

    saveCropImage = () => {
        this.child.current.buttonclicked();
    }

    handleZoomIncrement = event => {
        this.setState({ zoom: this.state.zoom + Constants.changeInZoom });
    };

    handleZoomDecrement = event => {
        if (this.state.zoom >= this.state.minimumScale + Constants.minimumZoomThreshold) {
            this.setState({ zoom: this.state.zoom - Constants.changeInZoom });
        }
    };

    resetFileData = () => {
        this.setState({
            file: null,
            fileData: null,
            zoom: 1
        })
    }

    sendFileToNextPage = () => {
        this.props.imageUploadHandler(this.state.fileData)
    }

    validateSize(file) {
        var fileSizeMB = file.size / 1024 / 1024; // in MB
        var fileSizeKB = file.size / 1024; // in KB
        if (fileSizeMB < Constants.maximumImageSize && fileSizeKB > Constants.minimumImageSize) {
            return true
        } else {
            this.setState({
                modalHeading: Constants.headerImageSizeValidation,
                modalInfo: Constants.infoImageSizeValidation
            }, this.handleShow());
            return false;
        }
    }

    clickDashboardRoute = () => {
        this.props.imageUploadHandler(null)
    }

    render() {
        return (
            <div className="p-4">
                <div className="main-div p-4">
                    <div className="container-fluid">
                        <div className="row margin-bottom">
                            <div className="col mb-2" >
                                <span className="heading-h1 montserrat">Templates</span>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col">
                                <img src={NewTemplateIcon} style={{ marginRight: "5px", marginBottom: "5px", height: "34px", display: "inline-block" }} alt="NewTemplate-icon"/>
                                <span className="page-heading-upload ml-2 nunito" style={{ display: "inline-block" }}> New Template</span>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-6">
                                <Card>
                                    {this.state.file === null ?
                                        <Dropzone onDrop={this.onFileUpload} accept={[".png", ".jpg", ".jpeg"]} >
                                            {({ getRootProps, getInputProps }) => (
                                                <div className="container-fluid p-3">
                                                    <section className="card-border">
                                                        <div {...getRootProps()} className="drop-div" >
                                                            <div className="move-to-tenter" >
                                                                <div className="container-fluid">
                                                                    <div className="row pt-3" >
                                                                        <div className="col-12 ">
                                                                            <input {...getInputProps()} />
                                                                            <img style={{ height: "150px" }} src={require('../../assets/images/cloud-upload.svg')} alt="cloud-icon"/>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row pt-2" >
                                                                        <div className="col-12">
                                                                            <span className="new-template source-sans-pro" style={{ fontWeight: "500", fontSize: "x-large" }}>Drag image here or</span>

                                                                        </div>
                                                                    </div>
                                                                    <div className="row pt-2" >
                                                                        <div className="col-12">
                                                                            <button type="button" className="btn source-sans-pro button-text-class browse-image-btn" onChange={this.onFileUpload}>Browse for file</button>

                                                                        </div>
                                                                    </div>
                                                                    <div className="row pt-4" >
                                                                        <div className="col-12">
                                                                            <span className="source-sans-pro" style={{ fontSize: "13px", marginTop: "10px" }}>{Constants.dragDropText}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </section>
                                                </div>
                                            )}
                                        </Dropzone>
                                        :
                                        <div className="container-fluid">
                                            <div className="row pt-3">
                                                <div className="col pl-5 pr-5">
                                                    {this.state.perspectiveCrop ?
                                                        <div className="right-side">
                                                            <Tooltip title={ToolTipMessages.cancelCropButton}>
                                                                <input type="image" className="icon-img" onClick={this.cancelCropBtnClick} src={require('../../assets/images/times.svg')} alt="cancel"/>
                                                            </Tooltip>
                                                            <Tooltip title={ToolTipMessages.saveCroppedImageButton}>
                                                                <input type="image" className="icon-img" onClick={this.saveCropImage} src={require('../../assets/images/save.svg')} alt="save"/>
                                                            </Tooltip>
                                                            <Tooltip title={ToolTipMessages.zoomOutButton}>
                                                                <input type="image" className="icon-img" onClick={this.handleZoomDecrement} src={require('../../assets/images/zoom-out.svg')} alt="-"/>
                                                            </Tooltip>
                                                            <Tooltip title={ToolTipMessages.zoomInButton}>
                                                                <input type="image" className="icon-img" onClick={this.handleZoomIncrement} src={require('../../assets/images/zoom-in.svg')} alt="+"/>
                                                            </Tooltip>
                                                        </div>
                                                        :
                                                        <div className="right-side">
                                                            <Tooltip title={ToolTipMessages.cropImageButton}>
                                                                <input type="image" className="icon-img" onClick={this.perspectiveCropImage} src={require('../../assets/images/crop-icon.svg')} alt="crop"/>
                                                            </Tooltip>
                                                            <Tooltip title={ToolTipMessages.zoomOutButton}>
                                                                <input type="image" className="icon-img" onClick={this.handleZoomDecrement} src={require('../../assets/images/zoom-out.svg')} alt="-"/>
                                                            </Tooltip>
                                                            <Tooltip title={ToolTipMessages.zoomInButton}>
                                                                <input type="image" className="icon-img" onClick={this.handleZoomIncrement} src={require('../../assets/images/zoom-in.svg')} alt="+"/>
                                                            </Tooltip>
                                                            <Tooltip title={ToolTipMessages.resetImageButton}>
                                                                <input type="image" className="icon-img" onClick={this.resetFileData} src={require('../../assets/images/delete-disabled.svg')}alt="clear image" />
                                                            </Tooltip>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                            <div className="row pt-2">
                                                <div className="col pl-5 pr-5">
                                                    <div className="image-area" >
                                                        <div style={{
                                                            width: parseInt((this.state.zoom * this.state.imgWidth).toFixed()) + "px",
                                                            height: parseInt((this.state.zoom * this.state.imgHeight).toFixed()) + "px"}}>
                                                            <div ref={(div) => { this.transformDiv = div }} className="image-transform-div" id="transform-div" style={{ transform: 'scale(' + this.state.zoom + ')' }}>
                                                                {this.state.perspectiveCrop ?
                                                                    <Perspectivecrop cropComplete={this.cropComplete} zoom={this.state.zoom} src={this.state.file} ref={this.child} />
                                                                    : <img src={this.state.file} />}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row pt-2 mb-2">
                                                <div className="col ">
                                                    <div className="upload-image">
                                                        <Link className="btn button-text-class source-sans-pro upload-image-btn" onClick={this.sendFileToNextPage} to="/create-template">Upload Image</Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </Card>
                            </div>
                            <div className="col"/>
                            <Modal className="modal-style text-justify source-sans-pro" show={this.state.show} onHide={this.handleClose}>
                                <Modal.Header closeButton>
                                    <Modal.Title>{this.state.modalHeading}</Modal.Title>
                                </Modal.Header>
                                <Modal.Body className="table-view">
                                    {this.state.modalInfo}
                                </Modal.Body>
                            </Modal>
                        </div>
                        <div className="row pt-3">
                            <div className="col">
                                <Link style={{ width: "160px",     height: "40px" }} className=" btn mt-3 mr-2 application-theme-color" onClick={this.clickDashboardRoute} to="/">Dashboard</Link>
                            </div>
                        </div >
                    </div>
                </div >
            </div>
        )
    }
}

export default UploadImage;
